export class ImosMenu extends HTMLElement {
  private _visible = false;

  get visible(): boolean {
    return this._visible;
  }

  connectedCallback(): void {
    // Listen for menu toggle events from triggers elsewhere on the page
    window.addEventListener('imos-menu-toggle', () => this.toggle());
    window.addEventListener('imos-menu-close', () => this.close());
  }

  toggle(): void {
    this._visible = !this._visible;
    this.apply();
  }

  close(): void {
    this._visible = false;
    this.apply();
  }

  private apply(): void {
    // Toggle class on the sidebar element inside this component
    const sidebar = this.querySelector('[data-sidebar]') as HTMLElement | null;
    if (sidebar) {
      sidebar.classList.toggle('appFrame__sidebar--open', this._visible);
    }

    // Update burger icon state
    const burger = document.querySelector('[data-menu-burger]');
    if (burger) {
      burger.classList.toggle('burger--isOpen', this._visible);
    }
  }
}

customElements.define('imos-menu', ImosMenu);
